import { useState } from "react"
import parsePhoneNumber from 'libphonenumber-js'
import { AsYouType } from "libphonenumber-js"
import { useShareFiado } from "./useShareFiado"
import { AuthContext } from "../context/AuthContext"
import { useContext } from "react"
export const usePhoneFormat = ()=>{
    const { setLoading,checkToken } = useContext(AuthContext);

    const [phoneFormated,setPhoneFormated] = useState("")
    const {getFirstDigits} = useShareFiado()

    const formatNumberToNational = (number)=>{
        checkToken()
        try {
            let phoneNumber = parsePhoneNumber(number)
            phoneNumber = phoneNumber.formatNational()
            return phoneNumber;
        } catch (error) {
            //console.log(error)
            return false
        }

    }

    const formatNumberToNationalWithoutSpaces = (number)=>{
        checkToken()
        try {
        
            let numberToLocal = formatNumberToNational(number);
            let numWithoutSpaces = numberToLocal.replace(/ /g,"");
            return numWithoutSpaces;
        } catch (error) {
      
        }

    }

    const getCountryCode =(number)=>{
        let phoneNumber = parsePhoneNumber(number)
        let countryCode = phoneNumber?.countryCallingCode
        return countryCode
    }

    const typingPhoneNumber = (number)=>{
        let formatedNumber = new AsYouType('MX').input(number)
        //console.log(formatedNumber);
        return formatedNumber;
    }



    

    const phoneNumberWithEmoji = (number)=>{

        let countryFlags = {
            "52": "🇲🇽",
            "57": "🇨🇴",
            "1":"🇺🇸",
            "default": ""
        }

        let phoneNumber = formatNumberToNational(number);
        let countryFlag =countryFlags[getCountryCode(number)] ? countryFlags[getCountryCode(number)] : countryFlags["default"];
        let phoneWithEmoji = `${countryFlag} ${phoneNumber}`
        return phoneWithEmoji;
    }

    const validateLocalPhone = (phone)=>{

        if ( getFirstDigits(phone) === '+1' && phone.length === 12 ) {
            return true
        } else if ((getFirstDigits(phone) === '+52' || '+57') && phone.length === 13 ) {
            return true
        } else {
            return false
        }
        

       //console.log(phone)
       //return true
        // try {
        //     let number = formatNumberToNationalWithoutSpaces(phone);
        //    // console.log(number)
        //     if(number.length == 10){
        //         return true;}
        //     else{
        //         return false;
        //     }
        // } catch (error) {
        //     //console.log(error)
        //     return false;
        // }
  
    }

    const inputFormatValidation = (phone,stateVal)=>{
        checkToken()
        try {
          if(phone.length < 11){
            if(phone.match(/^[0-9]\d*?$/)){
                //console.log(phone)
              return phone
            }
          }else{
            return stateVal
          }
        } catch (error) {
          //console.log(error)
          return ""
        }
      }

    return {typingPhoneNumber,formatNumberToNational,phoneNumberWithEmoji,formatNumberToNationalWithoutSpaces,validateLocalPhone,inputFormatValidation,getCountryCode}
}